const buttonStyle = {
  height: 42, // 25..55
  color: "blue",
}

// https://developer.paypal.com/docs/checkout/advanced/customize/card-field-style/
const cardStyle = () => {
  const styles = getComputedStyle(document.body)

  return {
    input: {
      "font-family": "monospace",
      padding: ".5rem 1rem",
    },
    ".valid": {
      color: styles.getPropertyValue("--color-success-500"),
    },
    ".invalid": {
      color: styles.getPropertyValue("--color-error-500"),
    },
  }
}

export { buttonStyle, cardStyle }
